import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";

import './FinalPage.scss'
import Icon from "../../icon/Icon";

interface Props extends WithTranslation{
    message:string;
};

interface State {

};

class FinalPage extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
        }
    }

    renderTextInformation() {
        let {message, t} = this.props;

        return <div
            className="final-text fade-in"
            style={{
                backgroundColor: "whitesmoke",
                padding: "0.5rem",
                borderRadius: "0.25rem",
            }}>
            <Icon type={"CHECKMARK"} iconProps={{ size: '6rem' }} />

            {(t(message as unknown as TemplateStringsArray) as string).split('\n').map(s => <div className="info-row">{s}</div>)}
        </div >
    }

    render() {
        return <>
            {this.renderTextInformation()}
        </>
    }
};

export default withTranslation()(FinalPage);